import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Modal from 'cccisd-modal';
import axios from 'cccisd-axios';
import Tooltip from 'cccisd-tooltip';
import notification from 'cccisd-notification';
import IconPencil from 'cccisd-icons/pencil';

import SupervisorForm from 'js/components/SupervisorForm';

const Boilerplate = window.cccisd && window.cccisd.boilerplate;

const EditSupervisor = props => {
    const modal = useRef();
    const { row, loadData } = props;

    const onSubmit = async values => {
        const response = await axios.put(Boilerplate.route('api.nexus.pawn.update', { pawn: row['pawn.pawnId'] }), {
            pawnHash: row['pawn.pawnHash'],
            role: 'supervisor',
            firstName: values.firstName,
            first_name: values.firstName,
            lastName: values.lastName,
            last_name: values.lastName,
            managePageAccess: values.managePageAccess,
            dashboardPageAccess: values.dashboardPageAccess,
            administerPageAccess: values.administerPageAccess,
            group: values.site,
        });

        if (response.data.errors) {
            let errorMessage = response.data.errors;
            if (typeof response.data.errors === 'object') {
                errorMessage = Object.values(response.data.errors).flat().join(' ');
            }
            notification({ type: 'danger', message: errorMessage });
            return Promise.reject(response.data.errors);
        }

        await loadData();
        notification({ type: 'success', message: 'Supervisor edited.' });
        await modal.current.close();
    };

    return (
        <Modal
            ref={modal}
            trigger={
                <Tooltip title="Edit">
                    <button type="button" className="btn btn-xs btn-success">
                        <IconPencil />
                    </button>
                </Tooltip>
            }
            title="Edit Supervisor"
        >
            <SupervisorForm
                onSubmit={onSubmit}
                isEdit
                initialValues={{
                    email: row['user.username'],
                    firstName: row['user.firstName'],
                    lastName: row['user.lastName'],
                    managePageAccess: row['fields.managePageAccess'] || false,
                    dashboardPageAccess: row['fields.dashboardPageAccess'] || false,
                    administerPageAccess: row['fields.administerPageAccess'] || false,
                    site: [row['ancestorGroups.site.group.groupId']],
                    siteName: row['ancestorGroups.site.group.label'],
                }}
            />
        </Modal>
    );
};

EditSupervisor.propTypes = {
    loadData: PropTypes.func,
    row: PropTypes.object,
};

export default EditSupervisor;
